import { cardSeen, everyCityDone } from '../../services/cityRoles.js';
import type { FeatureManifest } from '../registry.js';

/**
 * Roadmap-3k city moments (launch plan Phase 1 step 6): a city's Grand Opening celebration and
 * the next city's card (opened by the win flow, PlayScene), and the end-of-content card ("You've
 * visited every city!"): after the last city's Grand Opening, once on the map when every city's
 * last level is beaten, and from the journey's last banner after that.
 */
export default {
  id: 'citycards',
  provides: ['cityOpening', 'nextCity', 'endOfContent'],
  // a results card: after the deliveries and results (10–22), before the offers (30)
  mapOrder: 24,
  mapDue: (a) => !cardSeen(a.services.store.state, 'end') && everyCityDone(a.services.store.state),
  load: () => import('./index.js'),
} satisfies FeatureManifest;
